import React from 'react'
import ReactDOM from 'react-dom/client'
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react'
import theme from './theme'
import App from './App'
import { Helmet } from 'react-helmet'
import reportWebVitals from './reportWebVitals'
import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <ChakraProvider
      theme={theme}
      toastOptions={{ defaultOptions: { position: 'bottom-right', duration: 7000 } }}
    >
      <Helmet>
        <meta charSet='utf-8' />
        <title>Songvisor | AI Assistant for Music Supervisors</title>
      </Helmet>
      <App />
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    </ChakraProvider>
  </React.StrictMode>,
)

reportWebVitals()
